import HomeDepotLogoSVG from "./LG-HD-Product-Guide-Logo.svg"
import styles from "./BrandLogos.module.css"


const HomeDepotLogo = () => {
    return <div className={styles.logoContainer}><img alt="LG Home Depot Product Guide Logo" src={HomeDepotLogoSVG}/></div>;
}

export default HomeDepotLogo;